import { Stack, Typography } from "@mui/material";
import { motion } from "framer-motion";

const Hello = () => {
  return (
    <Stack spacing={1}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <Typography 
            variant="h4" 
            fontWeight={400} 
            color="rgba(255, 255, 255, 0.6)"
            sx={{ letterSpacing: '0.1em', textTransform: 'uppercase', fontSize: '1.2rem' }}
        >
          Daniel Obima
        </Typography>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
      >
        <Typography 
            variant="h1" 
            sx={{ 
                fontSize: { xs: '3.5rem', md: '5.5rem' },
                lineHeight: 1.1,
                background: 'linear-gradient(to right, #fff 20%, #22d3ee 50%, #818cf8 80%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundSize: '200% auto',
                animation: 'shine 5s linear infinite',
                '@keyframes shine': {
                    '0%': { backgroundPosition: '0% center' },
                    '100%': { backgroundPosition: '200% center' }
                }
            }}
        >
          Crafting digital <br /> experiences.
        </Typography>
      </motion.div>
    </Stack>
  );
};
export default Hello;
